import React from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import profileImage from '../assets/profileImage.jpg';
import { ReactComponent as Close } from '../assets/error.svg';
import { UnderlineText, Emoji, Section } from '../components/common';

const handleOnClick = () => {
  if (window && window.drift) {
    window.drift.on('ready', ({ openChat }) => openChat());
  }
};

const About = props => {
  return (
    <AboutSection>
      <AboutWrapper>
        <TextWrapper>
          <HeadlineWrapper>
            <ProfileImage src={profileImage} />
            <div>
              <Primary>Tuan Phung</Primary>
              <Secondary>
                <Emoji value="👨‍💻" />
                Front end dev / <Emoji value="🚀" />
                Maker / <Emoji value="🍌" />
                Banán
              </Secondary>
            </div>
          </HeadlineWrapper>
          <HeadlineWrapper>
            <Headline>
              Jak vznikl tento web? <Emoji value="🤔" />
            </Headline>
          </HeadlineWrapper>
          <div>
            Jsem fanoušek technologií/startupů a pravidelně sleduji productHunt a další kanály o
            zajímavých produktech a startupech. <Emoji value="🚀" />
          </div>
          <div>
            Říkal jsem si, proč vlastně není nic takového pro české projekty? <Emoji value="🇨🇿" />
          </div>
          <div>
            Long story short, po pár hodinách vzknikl tenhle web <Emoji value="🎉" />
          </div>
          <div>
            Chci vytvořit takový "showroom" českých projektů a startupů, tak uvidíme jak to půjde.{' '}
            <Emoji value="🤞🙏" />
          </div>
          <div>
            Máte nějaký komentáře nebo návrhy? <Emoji value="👉" />
            <UnderlineText onClick={handleOnClick}>napište mi sem!</UnderlineText>
          </div>
          <Emoji value="" />
          <ItalicText>
            #LetsBuildSomethingCool
            <Emoji value="😎" /> #weekendHacking #InJsWeTrust #tooManyHashTags
          </ItalicText>
        </TextWrapper>
      </AboutWrapper>
      <StyledClose onClick={props.history.goBack} />
    </AboutSection>
  );
};

const AboutSection = styled(Section)`
  @media (min-width: 600px) {
    display: flex;
    align-items: center;
    height: 100%;
    overflow-x: hidden;
  }
`;

export default withRouter(About);

const HeadlineWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Headline = styled.div`
  font-size: 32px;
`;

const Primary = styled.div`
  font-size: ${props => props.theme.font.small}px;
  color: ${props => props.theme.primaryTextColor};
`;

const Secondary = styled.div`
  font-size: ${props => props.theme.font.small}px;
  color: ${props => props.theme.secondaryTextColor};
`;

const StyledClose = styled(Close)`
  width: 32px;
  height: 32px;
  cursor: pointer;
  position: absolute;
  top: 32px;
  right: 32px;
`;

const ProfileImage = styled.div`
  background-image: url(${props => props.src});
  width: 64px;
  height: 64px;
  background-size: cover;
  border-radius: 50%;
  min-width: 64px;
`;

const AboutWrapper = styled.div`
  display: flex;
  ${ProfileImage} {
    margin-right: 24px;
  }
`;

const TextWrapper = styled.div`
  & > * {
    font-size: 16px;
    color: #898989;
    line-height: 1.5;
    margin: 0;
    max-width: 600px;
    margin-bottom: 20px;
  }

  @media (max-width: 600px) {
    padding-top: 64px;
  }
`;

const ItalicText = styled.div`
  color: #898989;
  line-height: 1.5;
  font-style: italic;
  font-size: 14px;
`;
